import { Tab } from "../../../../components/layout/types";
import { LayoutActionKey } from "../../../actions/ActionKeys";
import { LayoutAction } from "../../../actions/layout";

export const tabsById = (
  state: { [id: string]: Tab } = {
    editor: {
      id: "editor",
      title: "Notebook Draft",
      renderer: "editor",
      isFixed: true,
    },
  },
  action: LayoutAction
): { [id: string]: Tab } => {
  switch (action.type) {
    case LayoutActionKey.ADD_TAB:
      return {
        ...state,
        [action.payload.tab.id]: action.payload.tab,
      };
    default:
      return state;
  }
};
